export default async ({ $api, redirect, route, store }) => {
  const user = store.getters['user/get'];
  if (user === null) {
    redirect('/users/login/');
    return;
  }

  const $i18n = store.$i18n;
  const subpage = route.params.subpage;
  let breadcrumbs = route.meta[0].breadcrumbs;
  let metaTagOptions = {};

  if (subpage) {
    store.commit('account/setAccountSubpage', subpage);
    breadcrumbs = [['i18n/home', '/'], ['i18n/account', '/account/profile/'], [`i18n/${subpage}`]];
    if (subpage === 'orders') {
      store.commit('account/setOrders', null);
      const page = route.query.page;
      await $api('users/orders', { page }).then(r => {
        store.commit('account/setOrders', r);
      });
    }
  } else {
    const { orderType, code } = route.params;
    if (orderType && code) {
      breadcrumbs = [['i18n/home', '/'], ['i18n/account', '/account/profile/'], ['i18n/orders', '/account/orders/'], [code]];
      const pageTitle = $i18n.t('pageInfo.account.your-order');
      metaTagOptions = { title: pageTitle };
      store.commit('account/setOrderType', orderType);
      await $api(`users/orders/${orderType}/${code}`).then(r => {
        store.commit('account/setOrder', r);
      });
    }
  }

  const householdAddress = user.supply_address;
  if (householdAddress) {
    store.commit('utils/setAddress', householdAddress);
  }

  const jumboTitle = $i18n.t('pageInfo.account.hi-user', { fname: user.fname });
  route.meta[0] = {
    ...route.meta[0],
    ...{ breadcrumbs, metaTagOptions },
    title: jumboTitle
  };
};
